import { LoginPage } from 'pages/Login/LoginPage'
import { getProtectedRoutes } from './ProtectedNavigation'
import {
  createBrowserRouter,
  RouterProvider,
  Route,
  createRoutesFromElements,
} from 'react-router-dom'
import { getDeveloperRoutes } from './DeveloperNavigation'
import { ProtectedLayout } from './ProtectedLayout'
import { SupportTools } from 'pages/SupportTools/SupportTools'
import { useMemo } from 'react'
import { groupPermissionStore } from 'stores/groupPermissionStore'
import { featureAccessStore } from 'stores/featureAccessStore'

export const Navigation = () => {
  const permissions = groupPermissionStore((state) => state)
  // Feature access is fetched after login, so the router must rebuild when it changes.
  const featureAccess = featureAccessStore((state) => state)

  const router = useMemo(
    () =>
      createBrowserRouter(
        createRoutesFromElements(
          <>
            <Route path="/" element={<LoginPage />} />
            <Route element={<ProtectedLayout />}>
              {getProtectedRoutes(permissions)}
              {getDeveloperRoutes()}
              {import.meta.env.VITE_ENABLE_SUPPORT_TOOLS === 'true' &&
                permissions.supportToolsPermission && (
                  <Route
                    path="SupportTools"
                    key="SupportTools"
                    element={<SupportTools />}
                  />
                )}
            </Route>
          </>
        )
      ),
    [permissions, featureAccess]
  )

  return <RouterProvider router={router} />
}
